import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, InputNumber } from "rsuite";

const TreatmentModal = ({
  isOpen,
  onClose,
  onSave,
  mode = "add",
  initialValues,
}) => {
  const [form, setForm] = useState({ name: "", price: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (initialValues) {
        setForm({
          name: initialValues.name ?? "",
          price: initialValues.price != null ? String(initialValues.price) : "",
        });
      } else {
        setForm({ name: "", price: "" });
      }
      setErrors({});
    }
  }, [isOpen, initialValues]);

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) {
      nextErrors.name = "Treatment name is required";
    }

    const priceNum = Number(form.price);
    if (!form.price.trim()) {
      nextErrors.price = "Price is required";
    } else if (Number.isNaN(priceNum) || priceNum <= 0) {
      nextErrors.price = "Enter a valid price greater than 0";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    setSubmitting(true);
    const payload = {
      name: form.name.trim(),
      price: Number(form.price),
    };
    onSave(payload);
    setSubmitting(false);
  };

  const handleClose = () => {
    if (submitting) return;
    setErrors({});
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose} backdrop={submitting ? "static" : true} size="sm">
      <Modal.Header>
        <Modal.Title>{mode === "edit" ? "Edit treatment" : "Add treatment"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form fluid>
          <Form.Group>
            <Form.ControlLabel>Treatment name</Form.ControlLabel>
            <Input
              name="name"
              placeholder="e.g. Shirodhara"
              value={form.name}
              onChange={(value) => setForm((prev) => ({ ...prev, name: value }))}
              errorMessage={errors.name}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Price (₹)</Form.ControlLabel>
            <InputNumber
              name="price"
              placeholder="0.00"
              min={0}
              step={0.01}
              value={form.price ? Number(form.price) : null}
              onChange={(value) => setForm((prev) => ({ ...prev, price: value ? String(value) : "" }))}
              style={{ width: "100%" }}
            />
            {errors.price && (
              <div style={{ color: "#dc2626", fontSize: "0.875rem", marginTop: "4px" }}>
                {errors.price}
              </div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleClose} appearance="subtle" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          appearance="primary"
          style={{ backgroundColor: "#198754", color: "white" }}
          disabled={submitting}
        >
          {submitting
            ? mode === "edit"
              ? "Saving…"
              : "Adding…"
            : mode === "edit"
            ? "Save changes"
            : "Add treatment"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TreatmentModal;


